var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('memlist-modal',{ref:"edit-form",attrs:{"size":"xxl"}},[_c('SalesEditor',{attrs:{"refs":"sales-editor","sale_id":_vm.sale_id,"current_call_id":_vm.current_call_id},on:{"cancel":_vm.cancelled,"created":_vm.created,"updated":_vm.updated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }